(() => {
  'use strict';
  const source = new URL(location.href);
  const passThrough = new Set(['fbclid', 'gclid', 'ttclid', 'ad_id', 'adset_id', 'campaign_id', 'placement', 'ec_qa']);
  document.querySelectorAll('a[href*="/products/wandry"]').forEach((a, index) => {
    const target = new URL(a.getAttribute('href'), location.href);
    for (const [key, value] of source.searchParams) {
      if (key.startsWith('utm_') || passThrough.has(key)) target.searchParams.set(key, value);
    }
    target.searchParams.set('article', '05');
    a.href = target.href;
    a.dataset.ecCta = String(index + 1);
    a.addEventListener('click', () => {
      try { window.EC_MEASURE?.event('article_product_click'); } catch (_) {}
    });
  });
})();

/* 画像の先読み（記事04と同じ型）。主画像の読込後、3000px手前に入った画像と上から順に2枚ずつを先に読み込む。 */
(() => {
  'use strict';
  const images = Array.from(document.querySelectorAll('#wa05 img[loading="lazy"]'));
  if (!images.length) return;
  const started = new WeakSet();
  function start(img) {
    if (started.has(img)) return;
    started.add(img);
    img.loading = 'eager';
    img.fetchPriority = 'low';
  }
  function observe() {
    if (!('IntersectionObserver' in window)) { images.forEach(start); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { start(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '3000px 0px 3000px 0px' });
    images.forEach((img) => io.observe(img));
  }
  function trickle() {
    let i = 0;
    const next = () => {
      while (i < images.length && started.has(images[i])) i++;
      if (i >= images.length) return;
      const img = images[i++];
      start(img);
      if (img.complete) next(); else { img.addEventListener('load', next, { once: true }); img.addEventListener('error', next, { once: true }); }
    };
    next(); next();
  }
  const go = () => { observe(); ('requestIdleCallback' in window ? requestIdleCallback(trickle, { timeout: 1500 }) : setTimeout(trickle, 300)); };
  const hero = document.querySelector('#wa05 .hero img');
  if (!hero || (hero.complete && hero.naturalWidth > 0)) go();
  else { hero.addEventListener('load', go, { once: true }); hero.addEventListener('error', go, { once: true }); }
})();
